import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import theme from 'styles/theme';
import { Chip, Column, Row } from 'components/pages/market/home/MarketItem';

function MarketVertItem({ item }) {
   const navigate = useNavigate();
   const navigateToMarket = id => navigate(`/market/${id}`);

   return (
      <MarketVertItemWrap onClick={() => navigateToMarket(item.whole_id)}>
         <MarketImg src={item.whole_img} alt={item.whole_name} />
         <InfoWrap>
            <MarketPlace>{item.market_type}</MarketPlace>
            <MarketName>{item.whole_name}</MarketName>
            <TagsWrap>
               {item.items_on_sale.map((tag, index) => {
                  return <Chip key={`${index}-${tag}`}>{tag}</Chip>;
               })}
            </TagsWrap>
         </InfoWrap>
      </MarketVertItemWrap>
   );
}

export default MarketVertItem;

const MarketVertItemWrap = styled(Column)`
   cursor: pointer;
   user-select: none;
   aspect-ratio: 136/192;
   box-shadow: 3px 3px 20px rgba(34, 37, 41, 0.05);
   border-radius: 8px;
   width: 136px;
   background-color: ${theme.color.white};
`;

const MarketImg = styled.img`
   aspect-ratio: 136/88;
   width: 136px;
   border-top-left-radius: 8px;
   border-top-right-radius: 8px;
`;

const InfoWrap = styled(Column)`
   padding: 12px;
`;

const MarketPlace = styled.p`
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   color: ${theme.color.gray700};
`;
const MarketName = styled.p`
   font-weight: 500;
   font-size: 14px;
   line-height: 20px;
   color: ${theme.color.gray900};
   margin-bottom: 16px;
`;
const TagsWrap = styled(Row)`
   width: 100%;
   min-height: 20px;
   flex-wrap: nowrap;
   overflow-x: scroll;
   gap: 4px;
   -ms-overflow-style: none;
   scrollbar-width: none;
   &::-webkit-scrollbar {
      display: none;
   }

   ${Chip} {
      white-space: nowrap;
      padding: 2px 6px;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
   }
`;
